<template>
  <div>
    <div class="img-wrapper">

      <div class="front text-center">
        <router-link :to="{ path: '/product/sidebar/'+product.id}">
        <!--
          <img
            :src='require("@/assets/images/ajax-loader.gif")'
            class="img-fluid bg-img w-100"
          />
        -->

          <template v-if="product.is_new_item === 1">
            <div class="overlay">
              <h4 class="new_overlay_text">NEW</h4>
            </div>
          </template>

          <img
            :src='product.productPictureURL_small || require("@/assets/images/no_image.jpg")'
            :id="product.id"
            class="img-fluid bg-img r-img" style="width:100%;"
            :alt="product.productName"
            :key="index"
          />
        </router-link>
      </div>

      <div class="addtocart_btn">
        <button
          class="add-button add_cart"
          @click="addToCart(product,1)"
        > <i class="fa fa-plus"></i>
        </button>
      </div>

      <div class="badge" v-if="getQtyInCart() > 0">
        {{getQtyInCart()}}
      </div>

      <div class="cart-info cart-wrap"></div>

    </div>

    <div class="product-detail text-left">
      <router-link :to="{ path: '/product/sidebar/'+product.id}">
        <h6 class="product-detail-p">
          {{product.productName}}
        </h6>
        <span class="thc_line">{{product.thc_line}}</span>
      </router-link>

      <template v-if="product.is_sale_item === 1">
        <h4 style="font-size: 14px; color: red">SALE {{ product.priceInMinorUnits * curr.curr | currency(curr.symbol) }}</h4>
      </template>
      <template v-else>
        <h4 style="font-size: 16px">{{ product.priceInMinorUnits * curr.curr | currency(curr.symbol) }}</h4>
      </template>

    </div>

  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  props: ['product', 'index'],
  data() {
    return {
      imageSrc: '',
      cartval: false,
      dismissCountDown: 0
    }
  },
  computed: {
    ...mapState({
      productslist: state => state.products.productslist
    }),
    ...mapGetters({
      curr: 'products/changeCurrency',
      cartItems: 'cart/cartItems',
    }),
  },
  methods: {
    getQtyInCart() {
      var qty_in_cart = 0;
      for(var i = 0; i < this.cartItems.length; i++) {
        if(this.cartItems[i].sku === this.product.sku) {
          qty_in_cart = this.cartItems[i].qty;
        }
      }
      return qty_in_cart;
    },
    getImgUrl(path) {
      return require('@/assets/images/' + path)
    },
    addToCart: function (product,qty) {
      this.cartval = true
      this.$emit('opencartmodel', this.cartval)
      this.$store.dispatch('cart/addToCart', {product,qty})
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
      this.$emit('alertseconds', this.dismissCountDown)
    },
    discountedPrice(product) {
      return product.price - (product.price * product.discount / 100)
    }
  }
}
</script>
<style scoped>

  @font-face {
   font-family: "Neue75";
   src: local("Neue75"),
   url('../../assets/fonts/Neue-Haas-Grotesk-Display-Pro-75-Bold.ttf') format("truetype");
  }

  .badge {
    color: white;
    background-color: red;
    border-radius: 50%;
    padding-top: 5px;
    width: 20px;
    aspect-ratio: 1;
    position: absolute;
    right: 0;
    top: 10%;
  }
  .add-button {
    text-align: center;
    color: white;
    border-radius: 50%;
    font-size: 12px;
    cursor: pointer;
    padding: 6px 10px !important;
    color: white;
    border: none;
    aspect-ratio: 1;
    background-color: rgb(150, 220, 255);
    position: absolute;
    right: -10px;
    bottom: 0px;
  }
 .neue75-font{
   font-family: "Neue75";
   margin: 10px 0!important;
 }

.overlay {
  position: absolute;
  background-color: rgba(256, 256, 256, 0.80);
  z-index: 1000;
  top: 5px;
  right: 20%;
  left: 20%;
}

.new_overlay_text {
  font-size: 16px;
  font-weight: 600;
  color: red;
  margin: 0;
}


</style>
